import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=01b32798"
import script from "./CreateEdit.vue?vue&type=script&lang=js"
export * from "./CreateEdit.vue?vue&type=script&lang=js"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=01b32798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports